<template>
  <section class="main-content">
    <section class="main-content__full section">
      <header class="section__header">
        <h1 class="section__title creatives__title">Creatives <span class="section__title--count">({{ totalAds }})</span></h1>

        <section class="section__header__area">
          <form class="section__header__area__pagination" v-if="adPagination" style="display: none;">
            <select v-model="adPagination.resultsPerPage">
              <option :value="6">6</option>
              <option :value="12">12</option>
              <option :value="24">24</option>
              <option :value="48">48</option>
              <option :value="96">96</option>
            </select> per Page

            <span v-if="adPagination.pages > 1">&nbsp;|&nbsp;</span>

            <button v-if="adPagination.pages > 1" :disabled="!(adPagination.page > 1)" v-on:click="prevPage">&#8592;</button>
            <span v-if="adPagination.pages > 1">Page {{adPagination.page}}</span>
            <button v-if="adPagination.pages > 1" :disabled="!(adPagination.page < adPagination.pages)" v-on:click="nextPage">&#8594;</button>
          </form>

          <form class="section__header__area__search search">
            <div class="input input--search">
              <input type="text" placeholder="Search ads" class="input__field" v-model="searchText" />
            </div>
          </form>

          <nav class="section__header__area__controls controls">
          </nav>
        </section>
      </header>
    </section>

    <section class="section">
      <section class="section__content banners">
        <ul class="banners__list">
          <li class="banners__item" v-for="banner in ads">
            <banner-item @copied="copyAd" @deleted="deleteAd" :title="banner.name" :id="banner.id" :format-id="banner.format_id" :link="banner.link" :size="banner.json.size" :banner="banner" :ref="'banner'+banner.id"></banner-item>
          </li>
        </ul>
      </section>
    </section>
  </section>
</template>

<script>
let filterFn = (val, item)=>{
  let { name } = item;

  return (name.toLowerCase().indexOf(val.toLowerCase()) > -1)
};

import {mapState} from 'vuex'

export default {
  name: 'Ads',
  methods: {
    deleteAd (id) {
      let store = this.$store;
      this.$modal.show('warning', {
        messageText: 'Are you sure you want to remove the selected ad?',
        buttonText: 'Delete ad',
        callback (params) {
          store.dispatch('advertisements/delete', id);
        }
      })
    },
    copyAd (id) {
      this.$store.dispatch('advertisements/copy', id)
    },
    getPaginatedResults(){
      let sliceStart = this.adPagination.page == 1 ? 0 : ( (this.adPagination.page-1) * this.adPagination.resultsPerPage );
      let sliceEnd = this.adPagination.resultsPerPage * this.adPagination.page;

      let ads = this.allAds;

      if(this.filterText && ads){
        ads = ads.filter(filterFn.bind(null, this.filterText));
      }

      this.ads = ads.slice(sliceStart, sliceEnd);

      if(this.ads.length < 1) {
        this.adsShown = false;
      } else {
        this.adsShown = true;
      }
    },
    prevPage(e){
      e.preventDefault();

      this.adPagination.page = this.adPagination.page - 1;
    },
    nextPage(e){
      e.preventDefault();

      this.adPagination.page = this.adPagination.page + 1;
    },
    showModal(ad) {
      this.$modal.show('export-ad', ad);
    }
  },
  mounted(){
    this.$store.subscribe(function(mutation, state){
      this.ads = this.$store.getters['advertisements/getSortedAds'];
    }.bind(this));
  },
  computed: {
    ...mapState('advertisements', {
      allAds: 'ads'
    }),
    totalAds: function(){
      return this.allAds.length;
    }
  },
  data () {
    var obj = {
      ads: this.$store.getters['advertisements/getSortedAds'],
      adPagination: {
        resultsPerPage: 1000,
        page: 1
      },
      initialAdPaginate: false,
      paginationApplied: false,
      searchText: null,
      filterText: '',
      adsShown: true
    }

    return obj;
  },
  watch: {
    ads(){
      if(!this.initialAdPaginate && this.ads.length){
        this.initialAdPaginate = true;
      }

      if(this.ads.length && this.allAds){
        let withFilter = this.allAds.filter(filterFn.bind(null, this.filterText));
        this.adPagination.pages = Math.ceil(withFilter.length / this.adPagination.resultsPerPage);
      }
    },
    initialAdPaginate(){
      setTimeout(()=>{
        this.ads = this.ads.slice(0, this.adPagination.resultsPerPage);
        this.paginationApplied = true;
      }, 100);
    },
    searchText(newVal){
      this.filterText = newVal;

      this.getPaginatedResults();
    },
    'adPagination.resultsPerPage'(newVal){
      this.getPaginatedResults();
      this.adPagination.page = 1;
    },
    'adPagination.page'(){
      this.getPaginatedResults();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Ads.vue